// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { transformToCamelCase } from '@/utils';
import t from '@/store/financialStatement/financialStatements.types';

const STALE_TIME = 1000 * 60 * 5; // 5 minutes

/**
 * Retrieve AR non-invoice transactions details.
 */
export function useARNonInvoiceTransactions(query, props) {
  return useRequestQuery(
    [t.AR_NON_INVOICE_TRANSACTIONS, query],
    {
      method: 'get',
      url: 'financial_statements/receivable_aging_summary/non-invoice-transactions',
      params: query,
    },
    {
      select: (res) => {
        console.log('Raw API Response:', res);
        console.log('Response data:', res.data);
        console.log('Response data.data:', res.data?.data);
        const transformedData = transformToCamelCase(res.data?.data);
        console.log('Transformed data:', transformedData);
        return transformedData;
      },
      staleTime: STALE_TIME,
      ...props,
    }
  );
}
